export const addSchemes = (schemes) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    
    if (
      !schemes.code || !schemes.name ||
      !schemes.activities
    ) {
      dispatch({
        type: "ADDED_SCHEMES_ERROR",
        err: { message: "Input field required." },
      });
    } else {
      
      firestore
        .collection("schemes")
        .add({
          code: schemes.code,
          name: schemes.name,
          activities: schemes.activities,
        })
        .then((resp) => {
          dispatch({
            type: "ADDED_SCHEMES",
            message: "Schemes added successfully.",
            id: resp.id,
          });
        })
        .catch((err) => {
          dispatch({ type: "ADDED_SCHEMES_ERROR", err });
        });
    }
  };
};

export const updateSchemes = (updatedSchemes, schemesId) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    if (
      !updatedSchemes.code ||
      !updatedSchemes.name ||
      !updatedSchemes.activities 
    ) {
      dispatch({
        type: "UPDATED_SCHEMES_ERROR",
        err: { message: "Input field required." },
      });
    } else {

      firestore
        .collection("schemes")
        .doc(schemesId)
        .update({
          code: updatedSchemes.code,
          name: updatedSchemes.name,
          activities: updatedSchemes.activities,
        })
        .then(() => {
          dispatch({
            type: "UPDATED_SCHEMES",
            message: "Schemes updated successfully.",
          });
        })
        .catch((err) => {
          dispatch({ type: "UPDATED_SCHEMES_ERROR", err });
        });
    }
  };
};